import { createApiHandler } from './handler';

const quotes = {
  apiClient: null,
  path: '/admin/quotes',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async validateIfShippingIsRequired(form) {
    try {
      const response = await this.apiClient.post(`${this.path}/validate-if-shipping-is-required`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async calculateShippingPrice(form) {
    try {
      const response = await this.apiClient.post(`${this.path}/calculate-shipping-price`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async recontact(id) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/recontact`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async cancelPlan(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/cancel`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateCurrentBudget(id, form) {
    try {
      const response = await this.apiClient.put(`${this.path}/current-budget/${id}`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async changeDiet(form) {
    try {
      const response = await this.apiClient.post(`${this.path}/change-diet`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async requestOrder(id) {
    try {
      const response = await this.apiClient.post(`${this.path}/request-order/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async refundPayment(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/refund-payment/${id}`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async toggleCourtesy(id) {
    try {
      const response = await this.apiClient.patch(`${this.path}/courtesy/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async activateCourtesyPlan(id, form) {
    try {
      const response = await this.apiClient.post(`${this.path}/courtesy/activate/${id}`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateCourtesySettings(id, form) {
    try {
      const response = await this.apiClient.patch(`${this.path}/courtesy/settings/${id}`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateAddress(id, form) {
    try {
      const response = await this.apiClient.put(`${this.path}/address/${id}`, form);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async changeDeliveryMode(id, payload) {
    try {
      const response = await this.apiClient.post(`${this.path}/change-delivery-mode/${id}`, payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async attachCoupon(id, code) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/coupon`, { code });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async detachCoupon(id) {
    try {
      const response = await this.apiClient.delete(`${this.path}/${id}/coupon`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async activateCash(id, payload) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/cash/activate`, payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async renewCash(id, payload) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/cash/renew`, payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateDietStatus(quoteId, dietId, status) {
    try {
      const response = await this.apiClient.patch(`${this.path}/${quoteId}/diets/${dietId}/status`, { status });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async generateDietCatchUpOrder(quoteId, dietId) {
    try {
      const response = await this.apiClient.post(`${this.path}/${quoteId}/diets/${dietId}/catch-up-order`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default quotes;
